import PropTypes from 'prop-types';
import React from 'react';
import { questionKey } from './reducer';
import { whyChange } from './actions';
import { connect } from 'react-redux';
import WhyField from './WhyField';

const SingleWhyField = ({ add_why, why_text, ...props }) =>
  add_why ? (
    <p>
      <label className="srv-q-why">
        <span className="fs-12 mb1 d-b">{why_text}</span>{' '}
        <WhyField add_why={add_why} {...props} />
      </label>
    </p>
  ) : null;

SingleWhyField.propTypes = {
  add_why: PropTypes.bool,
  name: PropTypes.string.isRequired,
  why_text: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return question ? { value: question.why.value } : {};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => dispatch(whyChange(e.target.value, ownProps.id)),
});

const ConnectedWhyField = connect(mapStateToProps, mapDispatchToProps)(
  SingleWhyField
);

export default ConnectedWhyField;
